import { setUserSettings } from '@/services/api';
import { USER_SETTINGS_KEY } from '@/state/user-settings/userSettings';
import { useMutation, useQueryClient } from 'react-query';

export function useUpdateUserSettings(refetchOnEnd = true) {
    const queryClient = useQueryClient();

    return useMutation(setUserSettings, {
        onSuccess: async data => {
            if (refetchOnEnd) {
                queryClient.setQueriesData(USER_SETTINGS_KEY, data);
                queryClient.refetchQueries(USER_SETTINGS_KEY);
            }
        },
        onError: () => {
            if (refetchOnEnd) {
                queryClient.refetchQueries(USER_SETTINGS_KEY);
            }
        },
    });
}
